export default {
    // 网页标题的后缀
    titleSuffix: process.env.VUE_APP_TITLE,
    // 路由模式，可选值为 history 或 hash
    routerMode: 'history',
    apiBaseURL: process.env.VUE_APP_API_BASEURL,
};
